import { Route, Redirect } from "react-router";
import { getAuthToken } from "../../utils";

//Wrapper for <Route> that redirects to login if not authenticated within the application
export default function PrivateRoute({children, ...rest}){

  // This won't automatically redirect on logout unless we bind the auth token to redux
  const authToken = getAuthToken();

  return (
    <Route
      {...rest}
      render={({ location }) =>
      authToken ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}